<template>
	<div></div>
</template>

<script>
export default {
  name: 'registerAgreement',
  data () {
    return {
      
    }
  },
}	
</script>


// WEBPACK FOOTER //
// src/contract/registerAgreement.vue